import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e1ad09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-verify-success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Your transaction is"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("on the way")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "It should arrive in the next few minutes.", -1))
const _hoisted_4 = { class: "send-verify-success__buttons" }

import SuccessIcon from "@/icons/send/success-icon.vue";
import BaseButton from "@/components/base-button/index.vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'send-verify-success',
  setup(__props) {

const router = useRouter();

const inviteAction = () => {
  router.push({ name: "invite" });
};

const close = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SuccessIcon),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BaseButton, {
        title: "Invite friend",
        action: inviteAction
      }),
      _createVNode(BaseButton, {
        title: "Got it",
        stroke: true,
        action: close
      })
    ])
  ]))
}
}

})